import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { "data-club-info-modal-component": "" } },
    [
      _c(
        _vm.clubInfoModal,
        {
          tag: "component",
          attrs: {
            "show-info-club-service-price": _vm.showClubServicePriceInfo,
            title: _vm.modalTitle,
          },
        },
        [
          _c("img", {
            staticClass: "d-block mx-auto",
            class: _vm.isMobile ? "mb-8" : "mb-4",
            attrs: {
              src: "/static/_v1/pd/pictures/ui-kit/club.svg",
              alt: "Картинка Клуба",
              width: "150",
              height: "150",
            },
          }),
          _vm._v(" "),
          _c("ClubInfoModalContent", {
            attrs: {
              "club-info-list": _vm.clubInfoList,
              "use-list-element": _vm.showClubServicePriceInfo,
            },
          }),
          _vm._v(" "),
          !_vm.showClubServicePriceInfo
            ? _c("ClubInfoModalExpansionPanels", { staticClass: "mt-8" })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }